// Collection Product Cards functionality - matching home page behavior
(function () {
  function initCollectionProductCards() {
    // Handle variant selection via event delegation
    document.addEventListener('change', function (e) {
      const select = e.target.closest('.collection-variant-select');
      if (!select) return;

      const productId = select.dataset.productId;
      const selectedOption = select.options[select.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const image = selectedOption.dataset.image;

      const card = select.closest('.collection-product-card');
      if (!card) return;

      // Update price
      const priceElement = card.querySelector('.collection-product-price');
      if (priceElement && price) {
        // Format price using Shopify's money format
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }).format(price / 100);
        priceElement.textContent = formattedPrice;
        priceElement.dataset.price = price;
      }

      // Update image if variant has one
      const productImage = card.querySelector('.collection-product-image');
      if (productImage && image) {
        productImage.src = image;
      }

      // Update add to cart button variant ID and state
      const addToCartBtn = card.querySelector('.collection-add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;

        // Update availability
        const isAvailable = selectedOption.dataset.available === 'true';
        if (isAvailable) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
        }
      }

      // Update checkbox variant ID for bulk selection
      const checkbox = card.querySelector('.product-select-checkbox');
      if (checkbox) {
        checkbox.dataset.variantId = variantId;
        // If checkbox was checked, update the selection in bulk add to cart
        if (checkbox.checked && window.bulkAddToCart) {
          // Trigger change event to update the selection
          const changeEvent = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(changeEvent);
        }
      }

      // Update product card variant ID
      card.dataset.variantId = variantId;
    });

    // Handle add to cart functionality via event delegation
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.collection-add-to-cart-btn');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      // If button is already loading or disabled, don't trigger again
      if (button.classList.contains('loading') || button.disabled) return;

      const variantId = button.dataset.variantId;

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Add loading state
      button.classList.add('loading');
      const originalText = button.textContent;
      button.disabled = true;

      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(response => response.json())
        .then(data => {
          // Remove loading state
          button.classList.remove('loading');
          button.disabled = false;

          if (data.status && data.status === 422) {
            // Handle error (out of stock, etc.)
            alert(data.description || 'Unable to add item to cart');
            button.textContent = originalText;
          } else {
            // Success - update cart
            button.textContent = 'Added!';
            setTimeout(() => {
              button.textContent = 'Add to Cart';
            }, 2000);

            // Trigger cart update events
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-product-card', productVariantId: variantId });
            }

            // Update sticky cart count
            if (typeof window.updateStickyCart === 'function') {
              window.updateStickyCart();
            }
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          button.classList.remove('loading');
          button.disabled = false;
          button.textContent = originalText;
          alert('Error adding item to cart. Please try again.');
        });
    });

    // Handle stopPropagation for other elements
    document.addEventListener('click', function (e) {
      if (e.target.closest('.collection-variant-selector') || e.target.closest('.product-select-checkbox')) {
        e.stopPropagation();
      }
    });
  }

  // Only initialize once
  if (!window.collectionProductCardsInitialized) {
    initCollectionProductCards();
    window.collectionProductCardsInitialized = true;
  }
})();
